import { render } from "./CorporateClients.vue?vue&type=template&id=0465c040&scoped=true"
import script from "./CorporateClients.vue?vue&type=script&lang=js"
export * from "./CorporateClients.vue?vue&type=script&lang=js"

import "./CorporateClients.vue?vue&type=style&index=0&id=0465c040&scoped=true&lang=css"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0465c040"]])

export default __exports__